import Vue from 'vue'
import VueRouter from 'vue-router'
import {localStorageManage} from "@/common/localStorage/localStorageManage";

Vue.use(VueRouter)

const HOME_PATH = '/aftersaleOverview'

const router = new VueRouter({
  routes: [
    {
      path: '',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../page/login/login.vue')
    },
    {
      path: '/aftersaleOverview',
      name: 'aftersaleOverview',
      component: () => import('../page/home/aftersaleOverview/aftersaleOverview.vue')
    },
    // 兼容旧路由
    { path: '/robotOverviewShip', redirect: HOME_PATH },
    { path: '/robotOverview', redirect: HOME_PATH },
    { path: '/projectOverview', redirect: HOME_PATH },
    { path: '/home_swiper/index=:index', redirect: HOME_PATH },
    {
      path: '/userCenter',
      name: 'userCenter',
      component: () => import('../page/home/userCenter/userCenter.vue')
    },
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem(localStorageManage.token)
  if (!token && to.path !== '/login') {
    next('/login')
  } else if (token && to.path === '/login') {
    next(HOME_PATH)
  } else {
    next()
  }
})

export default router
